import { useEffect, useRef, useState } from "react";

export default function useIntersectionObserver(options = { threshold: 0.15, once: true }) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          if (options.once) observer.unobserve(entry.target);
        } else if (!options.once) {
          setInView(false);
        }
      },
      { threshold: options.threshold ?? 0.15 }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [options.threshold, options.once]);

  return [ref, inView];
}
